var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoodHappy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.25 35C28.5343 35 35.25 28.2843 35.25 20C35.25 11.7157 28.5343 5 20.25 5C11.9657 5 5.25 11.7157 5.25 20C5.25 28.2843 11.9657 35 20.25 35Z",
    stroke: "#18181B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.25 15H15.2667",
    stroke: "#18181B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.25 15H25.2667",
    stroke: "#18181B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9166 21.6667H13.5833M13.5833 21.6667C13.5833 23.4349 14.2856 25.1306 15.5359 26.3808C16.7861 27.631 18.4818 28.3334 20.2499 28.3334C22.018 28.3334 23.7137 27.631 24.964 26.3808C26.2142 25.1306 26.9166 23.4349 26.9166 21.6667H13.5833Z",
    stroke: "#18181B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoodHappy);
export default __webpack_public_path__ + "static/media/mood-happy.cff91df6835aab2654ea61e5271a9646.svg";
export { ForwardRef as ReactComponent };